<template>
  <div class='page plan'>
    <div v-if="!forbid">
      <div class='allow'>
        <div class="plan_options text-left" :class="getTopBanner ? 'position_plan_options_plus' : 'position_plan_options'">
          <div class="inner flex flex-col set-plan" :class='{active: !showDirections}' >
            <PlanLocations
              ref="planLocations"
              @push-markers='pushMarkers'
              @push-pause='pushPause'
              @set-locations-names='setLocationsNames'
              @set-waypoint-labels='setWaypointLabels'
              @reverse-points='reversePoints'
              :cached_markers='selected_points'
              :reset_all='reset_all'
              :selected_points_cloned='selected_points_cloned'
              :user-at='userAt'
            />
            <PlanOptions
              :reset_all='reset_all'
              @push_options='pushOptions'
              :transport_type='transport_type.id'
              :route_options='saved_route_options'
            />
            <DateSelect
              @selectDates='selectDates'
              :reset_all='reset_all'
              :route_line='routeLine'
              :initial_is_departure='pickerDates.is_departure'
              :picker_dates='pickerDates'
              :start_date_user_set='startDateUserSet'
              :end_date_user_set='endDateUserSet'
            />
            <PlanVehicles
              @selectVehicles='selectVehicles'
              :vehiclesDimensions='vehiclesDimensions'
              :reset_all='reset_all'
              @changedVehicleDimensions='changedVehicleDimensions'
            />
            <PlanTrailers
              v-if='!hide_tailers'
              @openTrailersPopup='showTrailersPopup'
              :trailersDimensions='trailersDimensions'
            />
            <PlanDrivers
              :selected_driver_id="selected_driver_id"
              @selectDriver='selectDriver'
            />
            <div class="actions generate w-full flex items-center">
              <button class="green-white w-full text-center flex items-center" @click="generatePlan()">Generate</button>
            </div>
          </div>
          <div class='inner view-plan ' v-if='showDirections'>
            <SaveRoute
              @edit_route='editRoute'
              @share_route='shareRoute'
              @save_route='saveRouteV2'
              @choose_route='updateSelectedRouteIndex'
              :route_data='routeLine'
              :selected_route_id='selected_route_id'
              :vehicles_dimensions='vehiclesDimensions'
            />
          </div>
        </div>
        <AltHeader class="alt_header"></AltHeader>
        <div
          v-if="planContextMenu.show"
          :style="{
            position: 'fixed',
            left: planContextMenu.x + 'px',
            top: planContextMenu.y + 'px',
            zIndex: 1000,
          }"
          class="plan-map-context-menu"
        >
          <div class="plan-map-context-menu-item" @click.stop="onPlanContextAction('start')">
            Add as Starting point
          </div>
          <div class="plan-map-context-menu-item" @click.stop="onPlanContextAction('destination')">
            Add as Destination
          </div>
          <div
            class="plan-map-context-menu-item"
            :class="{ disabled: !isPlanContextViaEnabled() }"
            @click.stop="onPlanContextAction('via')"
          >
            Add as Via point
          </div>
        </div>

        <HereMap
          ref="hereMap"
          v-if="userAt"
          :reset_all='reset_all'
          :routeData='routeLine'
          :selected_points='selected_points'
          :plan-map-pick-enabled="planMapPickEnabled"
          @update_points='updatePointsFromMap'
          @selected_way='updateSelectedWayIndex'
          @changed_way='changedWay'
          @plan-map-context-open="onPlanMapContextOpen"
          @plan-map-context-address="onPlanMapContextAddress"
          :is_edit='is_edit'
          :multi_points_center='multi_points_center'
          :selected_route_id='selected_route_id'
          :rote_replan='rote_replan'
          :stored_tmp_marker='tmp_markers'
          :initial-center='userAt'
          :zoom_default='mapZoom'
          :exclusion-overlays='exclusionOverlays'
      />

      </div>

      <div class="flex gap-15">
        <div class="add_items add_vehicles" v-if="openVehiclesPopUp"
         :class="{'w-1/3 minified': openTrailersPopup, 'w-2/3': !openTrailersPopup, }"
        >
          <PopupVehiclesSelect
            :reset_all='reset_all'
            @closeVehiclesPopup='closeVehiclesPopup'
            @setSelectedVehiclesDimensions='setSelectedVehiclesDimensions'
            :selected_vehicles_ids='selected_vehicles_ids'
          />
        </div>
        <div class="add_items add_trailers"
           :class="{'w-1/3 minified r-side': openVehiclesPopUp, 'w-2/3': !openVehiclesPopUp, }"
           v-if="openTrailersPopup">
          <PopupTrailersSelect
            :reset_all='reset_all'
            @closeTrailersPopup='closeTrailersPopup'
            @setSelectedTrailersDimensions='setSelectedTrailersDimensions'
            :selected_trailers_ids='selected_trailers_ids'
          />
        </div>
      </div>

      <SaveRoutePopup
        :open_route_name_popup="open_route_name_popup"
        :selected_driver_id="selected_driver_id"
        @close="open_route_name_popup = false"
        @saveDirections="storeRouteV2"
      />
    </div>
    <div v-else>
      <AltHeader class="alt_header"></AltHeader>
      <OutOfLimit
        class="not-allow-banner"
        :items="'routes'"
        :itemsProps="'routes limit'"
        :count="allowedCount"
      />
    </div>
  </div>
</template>

<script>

import HereMap from "@/components/HereMap.vue";
import {
  buildRouteInfoTimes,
  resolveGenerateAnchor,
  syncPlannedRouteDates,
} from "@/helpers/planned-route-dates";
import {baseErrHandler, generateRoute, getApplicableRoadExclusionsForMap, getRouteById, getTrailersByIds, getVehiclesByIds, storeRoute} from "@/services/api";
import {mapGetters, mapMutations} from "vuex";
import PlanLocations from "@/components/plan-elements/PlanLocations.vue";
import DateSelect from "@/components/plan-elements/DateSelect.vue";
import { resolveMapPickLocation } from "@/services/planMapLocation";
import PlanVehicles from "@/components/plan-elements/PlanVehicles.vue";
import PopupVehiclesSelect from "@/components/PopupVehiclesSelect.vue";
import PlanTrailers from "@/components/plan-elements/PlanTrailers.vue";
import PopupTrailersSelect from "@/components/PopupTrailersSelect.vue";
import PlanDrivers from "@/components/plan-elements/PlanDrivers.vue";
import structuredClone from "@ungap/structured-clone";
import AltHeader from "@/components/AltHeader.vue";
import SaveRoute from "@/components/plan-elements/SaveRoute.vue";
import SaveRoutePopup from "@/components/plan-elements/SaveRoutePopup.vue";
import PlanOptions from "@/components/plan-elements/PlanOptions.vue";
import {infoMessage} from "@/services/messages";
import OutOfLimit from "@/components/OutOfLimit.vue";
import {rebuildPointsByIndex} from "@/services/helpers";
import {getUserLocation, getMapZoomForLocation} from "@/services/userLocation";

export default {
  components: {
    OutOfLimit,
    PlanOptions,
    SaveRoutePopup,
    SaveRoute,
    AltHeader,
    PlanDrivers,
    PopupTrailersSelect,
    PlanTrailers,
    PopupVehiclesSelect,
    PlanVehicles,
    DateSelect,
    PlanLocations,
    HereMap
  },
  data() {
    const startDate = new Date();
    return {
      forbid: false,
      allowedCount: 0,
      userAt: null,
      mapZoom: 6.2,
      tmp_markers: [],
      saved_locations: [],
      hide_tailers: false,
      reset_all: false,
      changed_vehicle_dimensions: false,
      pickerDates: {
        startDate: startDate,
        endDate: null,
        is_departure: true
      },
      startDateUserSet: false,
      endDateUserSet: false,
      locations_names: {
        start: null,
        end: null
      },
      waypoint_labels: [],
      transport_type: {
        id: 'straightTruck',
        name: 'Straight Truck'
      },
      saved_option_id: null,
      routeLine: null,
      showDirections: false,
      is_edit: false,
      open_route_name_popup: false,
      openVehiclesPopUp: false,
      openTrailersPopup: false,
      multi_points_center: false,
      rote_replan: false,
      selected_driver_id: null,
      selected_way_index: 0,
      selected_route_id: 0,
      points_pauses: [],
      selected_points_cloned: [],
      points: [],
      selected_points: [],
      planContextMenu: {
        show: false,
        x: 0,
        y: 0,
        lat: null,
        lng: null,
        address: '',
      },
      vehiclesDimensions: {},
      vehiclesDimensionsClone: null,
      selectedVehicles: [],
      trailersDimensions: {},
      trailersDimensionsClone: null,
      selectedTrailers: [],
      selected_trailers_ids: [],
      selected_vehicles_ids: [],
      route_options: {
        toll_road: false,
        difficult_turns: false,
        tunnel: false,
        u_turns: false,
        motorway: false,
        mode: 'short',
        trafficData: false,
        excludedRoads: true,
        vehicles_dimensions: null,
        is_departure: true
      },
      saved_route_options: null,
      exclusionOverlays: [],
      exclusionOverlayTimer: null,
    }
  },
  methods: {
    ...mapMutations([
      'setLoading',
    ]),
    normalizeEntryExitArray(raw) {
      if (!raw) return [];
      let data = raw;
      if (typeof data === 'string') {
        const trimmed = data.trim();
        if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
          return [];
        }
        try {
          data = JSON.parse(trimmed);
        } catch (e) {
          console.error('Failed to parse entry/exit data', raw, e);
          return [];
        }
      }
      if (Array.isArray(data)) {
        return data.filter(
          (item) =>
            item &&
            item.coordinates &&
            typeof item.coordinates.latitude === 'number' &&
            typeof item.coordinates.longitude === 'number',
        );
      }
      if (
        typeof data === 'object' &&
        data !== null &&
        data.coordinates &&
        typeof data.coordinates.latitude === 'number' &&
        typeof data.coordinates.longitude === 'number'
      ) {
        return [data];
      }
      return [];
    },
    /**
     * Build tmp_markers that include:
     * - existing manual passthroughs (type: 'manual' or undefined)
     * - entry/exit points derived from saved locations, ordered as:
     *   Exit (current location) -> manual points -> Entry (next location) per section
     */
    async buildTmpMarkersWithEntryExit(currentTmpMarkers, selected_points) {
      const eps = 1e-6;
      const manualBySection = new Map();
      const entryBySection = new Map();
      const exitBySection = new Map();
      const existingEntryLocations = new Set();
      const existingExitLocations = new Set();

      const sectionCount = Array.isArray(selected_points)
        ? Math.max(selected_points.length - 1, 0)
        : 0;

      // Index existing markers by section and type
      (currentTmpMarkers || []).forEach((marker) => {
        const sectionIndex =
          typeof marker.sectionIndex === 'number' ? marker.sectionIndex : 0;
        const type = marker.type || 'manual';

        if (type === 'entry' && typeof marker.locationIndex === 'number') {
          existingEntryLocations.add(marker.locationIndex);
          if (!entryBySection.has(sectionIndex)) {
            entryBySection.set(sectionIndex, []);
          }
          entryBySection.get(sectionIndex).push(marker);
          return;
        }

        if (type === 'exit' && typeof marker.locationIndex === 'number') {
          existingExitLocations.add(marker.locationIndex);
          if (!exitBySection.has(sectionIndex)) {
            exitBySection.set(sectionIndex, []);
          }
          exitBySection.get(sectionIndex).push(marker);
          return;
        }

        // Default/manual passthroughs
        if (!manualBySection.has(sectionIndex)) {
          manualBySection.set(sectionIndex, []);
        }
        manualBySection.get(sectionIndex).push({
          ...marker,
          type: marker.type || 'manual',
        });
      });

      // Helper to find matching saved location for a given point
      const findLocationForPoint = (pt) => {
        if (!this.saved_locations?.length || !pt) return null;
        return (
          this.saved_locations.find((loc) => {
            const lat = loc?.geo?.latitude;
            const lng = loc?.geo?.longitude;
            if (typeof lat !== 'number' || typeof lng !== 'number') return false;
            return (
              Math.abs(lat - pt.lat) < eps && Math.abs(lng - pt.lng) < eps
            );
          }) || null
        );
      };

      // Build missing entry/exit markers from saved locations
      if (Array.isArray(selected_points) && selected_points.length > 1) {
        selected_points.forEach((pt, index) => {
          const loc = findLocationForPoint(pt);
          if (!loc) return;

          const entryPoints = this.normalizeEntryExitArray(loc.entry);
          const exitPoints = this.normalizeEntryExitArray(loc.exit);

          // Entry for location index>0 goes to previous section (index - 1)
          if (
            index > 0 &&
            entryPoints.length &&
            !existingEntryLocations.has(index)
          ) {
            const sectionIndex = index - 1;
            if (sectionIndex >= 0 && sectionIndex < sectionCount) {
              const list =
                entryBySection.get(sectionIndex) || [];
              entryPoints.forEach((entry) => {
                list.push({
                  sectionIndex,
                  coordinates: {
                    lat: entry.coordinates.latitude,
                    lng: entry.coordinates.longitude,
                  },
                  type: 'entry',
                  locationIndex: index,
                });
              });
              entryBySection.set(sectionIndex, list);
            }
          }

          // Exit for all but last location goes to current section (index)
          if (
            index < selected_points.length - 1 &&
            exitPoints.length &&
            !existingExitLocations.has(index)
          ) {
            const sectionIndex = index;
            if (sectionIndex >= 0 && sectionIndex < sectionCount) {
              const list =
                exitBySection.get(sectionIndex) || [];
              exitPoints.forEach((exit) => {
                list.push({
                  sectionIndex,
                  coordinates: {
                    lat: exit.coordinates.latitude,
                    lng: exit.coordinates.longitude,
                  },
                  type: 'exit',
                  locationIndex: index,
                });
              });
              exitBySection.set(sectionIndex, list);
            }
          }
        });
      }

      // Rebuild combined markers, ordered per section:
      // Exit -> Manual -> Entry
      const combined = [];
      for (let sectionIndex = 0; sectionIndex < sectionCount; sectionIndex++) {
        const exits = exitBySection.get(sectionIndex) || [];
        const manuals = manualBySection.get(sectionIndex) || [];
        const entries = entryBySection.get(sectionIndex) || [];
        combined.push(...exits, ...manuals, ...entries);
      }

      // If there are markers that reference a section index outside current range,
      // keep them as-is at the end to avoid losing anything unexpectedly.
      (currentTmpMarkers || []).forEach((marker) => {
        const sectionIndex =
          typeof marker.sectionIndex === 'number' ? marker.sectionIndex : 0;
        if (sectionIndex < 0 || sectionIndex >= sectionCount) {
          combined.push(marker);
        }
      });

      return combined;
    },
    addPoint() {

    },
    async reversePoints(index) {
      this.selected_points = await rebuildPointsByIndex(this.selected_points, index);

      this.tmp_markers = (this.tmp_markers || []).filter(
        (m) => m.type !== 'entry' && m.type !== 'exit',
      );
      this.tmp_markers = await this.buildTmpMarkersWithEntryExit(
        this.tmp_markers,
        this.selected_points,
      );
    },
    async updateSelectedWayIndex(val) {
      this.selected_way_index = val;
      const routeId = this.routeLine?.routes?.[val]?.id;
      if (routeId != null) {
        this.selected_route_id = routeId;
      }
    },
    changedVehicleDimensions() {
      this.changed_vehicle_dimensions = true;
      this.scheduleExclusionOverlayRefresh();
    },
    scheduleExclusionOverlayRefresh() {
      if (this.exclusionOverlayTimer) {
        clearTimeout(this.exclusionOverlayTimer);
      }
      this.exclusionOverlayTimer = setTimeout(() => {
        this.exclusionOverlayTimer = null;
        this.refreshExclusionOverlays();
      }, 300);
    },
    async refreshExclusionOverlays() {
      if (!this.userAt || !this.vehiclesDimensions?.weight) {
        return;
      }
      try {
        const response = await getApplicableRoadExclusionsForMap({
          vehicles_dimensions: this.vehiclesDimensions,
          trailers_dimensions: this.trailersDimensions,
          pickerDates: this.pickerDates,
          route_options: {
            excludedRoads: this.route_options.excludedRoads,
            is_departure: this.route_options.is_departure,
          },
        });
        this.exclusionOverlays = response.data?.items || [];
      } catch (e) {
        console.error(e);
        this.exclusionOverlays = [];
      }
    },
    async changedWay(val) {
      if(!val) {
        this.tmp_markers = [];
        return await this.generatePlan();
      }
      this.tmp_markers = val;
      await this.generatePlan(true);
    },
    async updateSelectedRouteIndex(val) {
      this.selected_route_id = val;
    },
    async pushPause(val) {
      this.points_pauses = val;
    },
    async pushMarkers(markers) {
      await this.resetPoints();
      await this.setPoints(markers);
      // Sidebar location changes: refresh entry/exit from saved locations (DB coords unchanged).
      const manual_tmp_markers = (this.tmp_markers || []).filter(
        (marker) =>
          marker.type !== 'entry' &&
          marker.type !== 'exit',
      );
      this.tmp_markers = await this.buildTmpMarkersWithEntryExit(
        manual_tmp_markers,
        this.selected_points,
      );
    },
    async updatePointsFromMap(markers) {
      if (!markers?.length) {
        return;
      }
      const prev = this.selected_points || [];
      const merged = markers.map((m, i) => {
        const prior = prev[i] || {};
        return {
          lat: m.lat,
          lng: m.lng,
          sidebarIndex:
            typeof prior.sidebarIndex === 'number' ? prior.sidebarIndex : i,
          role: prior.role,
        };
      });
      await this.resetPoints();
      await this.setPoints(merged);
      this.$refs.planLocations?.syncPositionsFromMapWaypoints(merged);
      // Map drag: keep passthrough/entry/exit positions in tmp_markers (route-only edits).
      if (this.is_edit && this.routeLine?.routes?.length) {
        await this.generatePlan(true);
      }
    },
    resetPoints() {
      this.selected_points = [];
    },
    setPoints(val) {
      this.selected_points = [];
      this.selected_points = val;
    },
    pushOptions(options) {
      const prevExcluded = this.route_options?.excludedRoads;
      this.route_options = options;
      if (prevExcluded !== options?.excludedRoads) {
        this.scheduleExclusionOverlayRefresh();
      }
    },
    selectDates(val) {
      if (!val) return;
      const {pickerDates, is_departure, startDateUserSet, endDateUserSet} = val;

      this.pickerDates = {
        startDate: pickerDates.startDate,
        endDate: pickerDates.endDate,
        is_departure: is_departure
      };
      if (startDateUserSet != null) {
        this.startDateUserSet = startDateUserSet;
      }
      if (endDateUserSet != null) {
        this.endDateUserSet = endDateUserSet;
      }
      this.route_options.is_departure = is_departure;
      this.scheduleExclusionOverlayRefresh();
    },
    applySyncedPlannedDates(directionData) {
      const synced = syncPlannedRouteDates(this.pickerDates, directionData, {
        userSetStart: this.startDateUserSet,
        userSetEnd: this.endDateUserSet,
      });
      this.pickerDates = {
        ...this.pickerDates,
        startDate: synced.startDate,
        endDate: synced.endDate,
      };
    },
    selectVehicles() {
      this.openVehiclesPopUp = true;
    },
    setLocationsNames(val) {
      this.locations_names = val;
    },
    setWaypointLabels(val) {
      this.waypoint_labels = Array.isArray(val) ? val : [];
    },
    findSavedLocationByCoords(lat, lng) {
      const eps = 1e-5;
      if (!this.saved_locations?.length) {
        return null;
      }
      return (
        this.saved_locations.find((loc) => {
          const locLat = loc?.geo?.latitude;
          const locLng = loc?.geo?.longitude;
          if (typeof locLat !== 'number' || typeof locLng !== 'number') {
            return false;
          }
          return (
            Math.abs(locLat - lat) < eps && Math.abs(locLng - lng) < eps
          );
        }) || null
      );
    },
    getWaypointPointCoords(point) {
      const pos = point?.point?.position;
      if (!pos) {
        return null;
      }
      const lat = typeof pos.lat === 'number' ? pos.lat : pos.Latitude;
      const lng = typeof pos.lng === 'number' ? pos.lng : pos.Longitude;
      if (
        typeof lat !== 'number' ||
        typeof lng !== 'number' ||
        isNaN(lat) ||
        isNaN(lng)
      ) {
        return null;
      }
      return { lat, lng };
    },
    formatAddressWithSavedName(name, geocodedAddress) {
      if (!name) {
        return geocodedAddress;
      }
      if (!geocodedAddress) {
        return name;
      }
      const prefix = name + ', ';
      if (geocodedAddress.startsWith(prefix) || geocodedAddress === name) {
        return geocodedAddress;
      }
      return prefix + geocodedAddress;
    },
    resolveWaypointLabel(index, totalPoints, route, coords) {
      const waypointLabels = route?.data?.route_info?.waypoint_labels;
      if (Array.isArray(waypointLabels) && waypointLabels[index]?.name) {
        return waypointLabels[index].name;
      }

      const saved = this.findSavedLocationByCoords(coords.lat, coords.lng);
      if (saved?.name) {
        return saved.name;
      }

      const locationsNames = route?.data?.route_info?.locations_names;
      if (index === 0 && locationsNames?.start) {
        return locationsNames.start;
      }
      if (index === totalPoints - 1 && locationsNames?.end) {
        return locationsNames.end;
      }
      return null;
    },
    restoreWaypointLabels(points, route) {
      if (!Array.isArray(points) || !points.length) {
        return;
      }

      const locationsNames = route?.data?.route_info?.locations_names;
      if (locationsNames) {
        this.locations_names = {
          start: locationsNames.start || null,
          end: locationsNames.end || null,
        };
      }

      const storedWaypointLabels = route?.data?.route_info?.waypoint_labels;
      if (Array.isArray(storedWaypointLabels) && storedWaypointLabels.length) {
        this.waypoint_labels = storedWaypointLabels;
      }

      points.forEach((point, index) => {
        const coords = this.getWaypointPointCoords(point);
        if (!coords) {
          return;
        }

        const savedName = this.resolveWaypointLabel(
          index,
          points.length,
          route,
          coords,
        );
        if (!savedName) {
          return;
        }

        point.name = savedName;
        point.point.address = this.formatAddressWithSavedName(
          savedName,
          point.point.address,
        );
      });

      if (!this.waypoint_labels?.length) {
        this.waypoint_labels = points.map((point) => {
          const coords = this.getWaypointPointCoords(point);
          return {
            name: point.name || null,
            lat: coords?.lat ?? null,
            lng: coords?.lng ?? null,
          };
        });
      }
    },
    closeVehiclesPopup() {
      this.openVehiclesPopUp = false;
    },
    showTrailersPopup() {
      this.openTrailersPopup = true;
    },
    closeTrailersPopup() {
      this.openTrailersPopup = false;
    },
    selectDriver(val) {
      if (!val) return;
      this.selected_driver_id = val;
    },
    selectTransportType(val) {
      if (!val) return;
      this.transport_type = val;
      this.route_options.transport_type = val.id;
    },
    editRoute(val) {
      if (!val) return;
      this.is_edit = true;
      this.showDirections = false;
    },
    shareRoute() {
    },
    saveRouteV2(val) {
      if (!val) return;
      this.open_route_name_popup = true;
    },
    computeMaxDimensionsFromVehicles(vehicles) {
      return (vehicles || []).reduce((max, vehicle) => ({
        width: Math.max(max.width, Number(vehicle.width) || 0),
        height: Math.max(max.height, Number(vehicle.height) || 0),
        length: Math.max(max.length, Number(vehicle.length) || 0),
        weight: Math.max(max.weight, Number(vehicle.weight) || 0),
      }), { width: 0, height: 0, length: 0, weight: 0 });
    },
    syncVehicleDimensionsFromVehicles(vehicles) {
      if (!vehicles?.length) {
        return;
      }
      const maxVehicleDimensions = this.computeMaxDimensionsFromVehicles(vehicles);
      this.vehiclesDimensions.width.val = maxVehicleDimensions.width;
      this.vehiclesDimensions.height.val = maxVehicleDimensions.height;
      this.vehiclesDimensions.length.val = maxVehicleDimensions.length;
      this.vehiclesDimensions.weight.val = maxVehicleDimensions.weight;
      this.scheduleExclusionOverlayRefresh();
    },
    computeMaxDimensionsFromTrailers(trailers) {
      return (trailers || []).reduce((max, trailer) => ({
        width: Math.max(max.width, Number(trailer.width) || 0),
        height: Math.max(max.height, Number(trailer.height) || 0),
        length: Math.max(max.length, Number(trailer.length) || 0),
      }), { width: 0, height: 0, length: 0 });
    },
    syncTrailerDimensionsFromTrailers(trailers) {
      if (!trailers?.length) {
        return;
      }
      const maxTrailerDimensions = this.computeMaxDimensionsFromTrailers(trailers);
      this.trailersDimensions.width.val = maxTrailerDimensions.width;
      this.trailersDimensions.height.val = maxTrailerDimensions.height;
      this.trailersDimensions.length.val = maxTrailerDimensions.length;
      this.scheduleExclusionOverlayRefresh();
    },
    syncSelectedVehiclesWithDimensions() {
      const { width, height, length, weight } = this.vehiclesDimensions;
      return (this.selectedVehicles || []).map((vehicle) => ({
        ...vehicle,
        width: width.val,
        height: height.val,
        length: length.val,
        weight: weight.val,
      }));
    },
    syncSelectedTrailersWithDimensions() {
      const { width, height, length } = this.trailersDimensions;
      return (this.selectedTrailers || []).map((trailer) => ({
        ...trailer,
        width: width.val,
        height: height.val,
        length: length.val,
      }));
    },
    async storeRouteV2(payload) {
      const name = typeof payload === 'string' ? payload : payload?.name;
      if (!name) {
        return;
      }
      if (payload && typeof payload === 'object') {
        this.selected_driver_id = payload.driver_id ?? null;
      }
      this.route_options.vehicles_dimensions = structuredClone(this.vehiclesDimensions);

      let is_re_plan = false;
      const replan_route_id = this.$route.query.replan_route_id;

      if (replan_route_id) {
        is_re_plan = true;
      }
      await baseErrHandler(async () => {
        const {routeLine, selected_driver_id} = this;
        const selectedVehicles = this.syncSelectedVehiclesWithDimensions();
        const selectedTrailers = this.syncSelectedTrailersWithDimensions();
        if(this.selected_way_index) {
          routeLine.routes[0] = routeLine.routes[this.selected_way_index];
        }

        //remove all routes except first
        routeLine.routes = [routeLine.routes[0]];
        const { time_start, time_end } = buildRouteInfoTimes(
          this.pickerDates,
          routeLine,
          {
            userSetStart: this.startDateUserSet,
            userSetEnd: this.endDateUserSet,
          },
        );
        const {data} = await storeRoute(
            {
              name,
              is_re_plan,
              vehicles_dimensions: this.vehiclesDimensions,
              trailers_dimensions: this.trailersDimensions,
              vehicle_info: selectedVehicles,
              direction_data: routeLine,
              driver_id: selected_driver_id,
              trailer_info: selectedTrailers,
              route_options: this.route_options,
              route_info: {
                tmp_markers: this.tmp_markers,
                locations_names: this.locations_names,
                waypoint_labels: this.waypoint_labels,
                time_end,
                time_start,
                is_departure: this.route_options.is_departure,
                locations: [
                  {
                    geo: {
                      region: routeLine.routes[0].sections[0].departure.place.address || null,
                      postcode: routeLine.routes[0].sections[0].departure.place.postalCode || null,
                      admin_district: null,
                    },
                    lat: routeLine.routes[0].sections[0].departure.place.originalLocation.lat,
                    lon: routeLine.routes[0].sections[0].departure.place.originalLocation.lng
                  }
                ],
                distance: this.partDistance,
              }
            });
        await this.$router.push({name: 'Routes'})
        if (data?.route_id) {
          this.setShareNewRouteId(data.route_id);
          // this.$router.push({name: 'SaveRoute', params: {id: data.route_id}})
        }
      });
    },
    setSelectedVehiclesDimensions(val) {
      const  {vDimensions, selectedVehicles} = val;
      this.vehiclesDimensions = structuredClone(vDimensions);
      this.selectedVehicles = selectedVehicles;
      if (val.selectedVehicles[0]?.vehicle_type) {
        this.transport_type = {
          id: val.selectedVehicles[0].vehicle_type
        }
      }
      val.selectedVehicles.forEach((vehicle) => {
        if ([
          "straightTruck",
          "tractor",
          "bus",
          "privateBus",
          "taxi",
          "car"
        ].includes(vehicle.transport_type)) {
          this.transport_type = {
            id: vehicle.transport_type
          }
        }
      });
      if ([
        "bus",
        "privateBus",
        "taxi",
        "car"
      ].includes(this.transport_type.id)) {
        this.hide_tailers = true;
      } else {
        this.hide_tailers = false;
      }
      this.scheduleExclusionOverlayRefresh();
    },
    setSelectedTrailersDimensions(val) {
      const  {tDimensions, selectedTrailers} = val;
      this.trailersDimensions = structuredClone(tDimensions);
      this.selectedTrailers = selectedTrailers;
      this.scheduleExclusionOverlayRefresh();
    },
    isPlanContextViaEnabled() {
      return this.$refs.planLocations?.hasAtLeastOneFilledPlace?.() ?? false;
    },
    hidePlanContextMenu() {
      this.planContextMenu.show = false;
    },
    onPlanMapContextOpen(payload) {
      this.planContextMenu = {
        show: true,
        x: payload.clientX,
        y: payload.clientY,
        lat: payload.lat,
        lng: payload.lng,
        address: payload.address || 'Loading address...',
      };
    },
    onPlanMapContextAddress({ address }) {
      if (this.planContextMenu.show) {
        this.planContextMenu.address = address;
      }
    },
    async fetchLocationByNameForMapPick(name) {
      try {
        const response = await this.$http.getAuth(
          `${this.$http.apiUrl()}/locations/${encodeURIComponent(name)}/get-by-name`,
        );
        return response?.data?.location || null;
      } catch (e) {
        return null;
      }
    },
    async onPlanContextAction(role) {
      if (role === 'via' && !this.isPlanContextViaEnabled()) {
        return;
      }
      const { lat, lng } = this.planContextMenu;
      let { address } = this.planContextMenu;
      this.hidePlanContextMenu();
      if (lat == null || lng == null) {
        return;
      }
      if (!address || address === 'Loading address...') {
        address = await this.$refs.hereMap?.reverseGeocodeAt(lat, lng);
      }
      const resolved = await resolveMapPickLocation({
        lat,
        lng,
        addressLabel: address,
        savedLocations: this.saved_locations,
        getLocationByName: (name) => this.fetchLocationByNameForMapPick(name),
      });
      this.$refs.hereMap?.clearPlanDraftPin();
      this.$refs.planLocations?.applyMapWaypoint({
        role,
        lat,
        lng,
        address: resolved.address,
        name: resolved.name,
        locationId: resolved.locationId,
        pendingCreate: resolved.pendingCreate,
        postcode: resolved.postcode,
      });
      if (this.is_edit && this.routeLine?.routes?.length) {
        await this.$nextTick();
        await this.generatePlan(true);
      }
    },
    async reloadSavedLocations() {
      try {
        const requestData = {
          skip: 0,
          take: 999,
          sort: 'name',
          column: 'name',
          search: '',
          ascending: false,
        };
        const response = await this.$http.getAuth(
          `${this.$http.apiUrl()}/locations?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`,
        );
        this.saved_locations = response?.data?.locations?.data || [];
      } catch (e) {
        console.error('Failed to reload saved locations', e);
      }
    },
    async persistPendingPlanLocations() {
      const pending =
        this.$refs.planLocations?.getPendingCreatePoints() || [];
      if (!pending.length) {
        return true;
      }
      const user = JSON.parse(localStorage.getItem('user'));
      for (const point of pending) {
        const pos = point.point.position;
        const name = point.name?.trim();
        if (!name) {
          infoMessage('Please fill all points', 'error');
          return false;
        }
        try {
          const test = await this.$http.getAuth(
            `${this.$http.apiUrl()}/locations/${encodeURIComponent(name)}/get-by-name`,
          );
          if (test?.data?.location) {
            infoMessage('Location name already exist', 'error');
            return false;
          }
        } catch (e) {
          /* name available */
        }
        const rawAddress = point.point.address || '';
        const address =
          point.name && rawAddress.startsWith(`${point.name}, `)
            ? rawAddress.slice(point.name.length + 2)
            : rawAddress;
        const payload = {
          name,
          user_id: user?.id,
          address,
          postcode: point.postcode ?? null,
          geo: {
            latitude: pos.Latitude,
            longitude: pos.Longitude,
          },
        };
        try {
          const response = await this.$http.postAuth(
            `${this.$http.apiUrl()}/locations/create`,
            payload,
          );
          if (!response?.data?.location) {
            infoMessage('Oops. Something went wrong...', 'error');
            return false;
          }
          point.pendingCreate = false;
          point.locationId = response.data.location.id ?? point.locationId;
        } catch (e) {
          const msg =
            e.response?.data?.message || 'Oops. Something went wrong...';
          infoMessage(
            typeof msg === 'string' ? msg : 'Oops. Something went wrong...',
            'error',
          );
          return false;
        }
      }
      await this.reloadSavedLocations();
      await this.$refs.planLocations?.getLocations();
      return true;
    },
    handlePlanContextMenuOutsideClick(event) {
      if (!this.planContextMenu.show) {
        return;
      }
      const el = event.target.closest('.plan-map-context-menu');
      if (!el) {
        this.hidePlanContextMenu();
        this.$refs.hereMap?.clearPlanDraftPin();
      }
    },
    async generatePlan(fromMapEdit = false) {
      this.multi_points_center = false;
      this.rote_replan = true;
      await baseErrHandler(async () => {
        this.$refs.planLocations?.emitNormalizedMarkers();
        await this.$nextTick();

        const persisted = await this.persistPendingPlanLocations();
        if (!persisted) {
          return;
        }
        this.$refs.planLocations?.emitNormalizedMarkers();
        await this.$nextTick();

        const {
            selected_points,
            vehiclesDimensions,
            trailersDimensions,
            pickerDates,
            transport_type,
            points_pauses
          } = this;
        if (!selected_points?.length || selected_points.length < 2) {
          infoMessage('Please fill all points', 'error');
          return;
        }
        const is_empty_point = selected_points.some((point) => {
          return (
            point.lat == null ||
            point.lng == null ||
            isNaN(point.lat) ||
            isNaN(point.lng) ||
            (point.lat === 0 && point.lng === 0)
          );
        });
        if (is_empty_point) {
          infoMessage('Please fill all points', 'error');
          return;
        }
 
        const date = new Date(pickerDates.startDate || pickerDates.endDate || new Date());
        const time_zone_offset = date.getTimezoneOffset();
        if (transport_type) {
          this.route_options['transport_type'] = transport_type.id;
        }

        const isDeparture = resolveGenerateAnchor({
          userSetStart: this.startDateUserSet,
          userSetEnd: this.endDateUserSet,
        });
        const generatePickerDates = {
          ...pickerDates,
          startDate: pickerDates.startDate || new Date(),
          endDate: pickerDates.endDate || pickerDates.startDate || new Date(),
          is_departure: isDeparture,
        };
        this.pickerDates.is_departure = isDeparture;
        this.route_options.is_departure = isDeparture;

        // Build combined tmp_markers that include entry/exit points (from saved locations)
        const routePoints = selected_points.map((pt) => ({
          lat: pt.lat,
          lng: pt.lng,
        }));

        const tmp_markers = await this.buildTmpMarkersWithEntryExit(
          this.tmp_markers,
          routePoints,
        );
        this.tmp_markers = tmp_markers;

        const {data} = await generateRoute(
            {
              time_zone_offset,
              selected_points: routePoints,
              vehicles_dimensions: vehiclesDimensions,
              trailers_dimensions: trailersDimensions,
              pickerDates: generatePickerDates,
              route_options: this.route_options,
              transport_type: transport_type.id,
              tmp_markers,
              points_pauses,
              is_departure: isDeparture
            });
        if (data?.name === 'Error') {
          infoMessage(
              data?.message || 'Oops. Something went wrong...',
              'error'
          );
        }
        if (data?.routes) {
          this.closeVehiclesPopup();
          this.closeTrailersPopup();
          this.routeLine = data;
          this.selected_way_index = 0;
          this.selected_route_id = data.routes[0]?.id ?? 0;
          this.applySyncedPlannedDates(data);
          if (fromMapEdit) {
            this.showDirections = false;
            this.is_edit = true;
          } else {
            this.showDirections = true;
            this.is_edit = false;
          }
        }
      });
    },
    async setData() {
      const isForbid = await this.$http.getAuth(`${this.$http.apiUrl()}/routes/forbid`);
      if (isForbid?.data?.forbid) {
        this.forbid = true;
        this.allowedCount = isForbid.data.count
      }
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.api_version === 'v1') {
        await this.$router.push({name: 'Plan'})
      }

      // Load saved locations (including entry/exit metadata) for entry/exit passthroughs
      try {
        const requestData = {
          skip: 0,
          take: 999,
          sort: 'name',
          column: 'name',
          search: '',
          ascending: false,
        };
        const response = await this.$http.getAuth(
          `${this.$http.apiUrl()}/locations?skip=${requestData.skip}&take=${requestData.take}&sort-by=${requestData.sort}&column=${requestData.column}&search=${requestData.search}&sort=${requestData.ascending}`,
        );
        this.saved_locations = response?.data?.locations?.data || [];
      } catch (e) {
        console.error('Failed to load locations for entry/exit points', e);
        this.saved_locations = [];
      }

      this.vehiclesDimensions = {
        width: {
          min: 1,
          max: 6,
          val: 2.5,
          step: 0.1,
          name: 'Width',
          dimention: 'm'

        },
        height: {
          min: 1,
          max: 10,
          val: 4,
          step: 0.1,
          name: 'Height',
          dimention: 'm'

        },
        length: {
          min: 1,
          max: 50,
          val: 12,
          step: 1,
          name: 'Length',
          dimention: 'm'

        },
        weight: {
          min: 1,
          max: 50,
          val: 18,
          step: 1,
          name: 'Weight',
          dimention: 't'

        },
      };
      this.trailersDimensions = {
        width: {
          min: 0,
          max: 6,
          val: 0,
          step: 0.1,
          name: 'Width',
          dimention: 'm'

        },
        height: {
          min: 0,
          max: 10,
          val: 0,
          step: 0.1,
          name: 'Height',
          dimention: 'm'

        },
        length: {
          min: 0,
          max: 50,
          val: 0,
          step: 0.5,
          name: 'Length',
          dimention: 'm'
        },
      };
      this.vehiclesDimensionsClone = structuredClone(this.vehiclesDimensions)
      this.trailersDimensionsClone = structuredClone(this.trailersDimensions)
    },
    async setRePlanData() {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.api_version === 'v1') {
        this.$router.push({name: 'Plan'})
      }
      const replan_route_id = this.$route.query.replan_route_id;
      if (!replan_route_id) {
        this.$router.push({name: 'Routes'})
      }
      this.multi_points_center = true;
      this.selected_points = [];
      const route = await getRouteById(replan_route_id);
      if (route.data.route_info?.tmp_markers) {
        this.tmp_markers = route.data.route_info?.tmp_markers;
      }
      if (route.data.direction_data?.routes[0]) {
        this.selected_points_cloned.push({
          point: {
            address: route.data.direction_data.routes[0].sections[0].departure.place.address,
            position: {
              lat: route.data.direction_data.routes[0].sections[0].departure.place.originalLocation.lat,
              lng: route.data.direction_data.routes[0].sections[0].departure.place.originalLocation.lng,
            }
          },
          origin_locations_open: false,
          points: null,
          showList: false,
          postcode: null
        });
        this.selected_points.push({
          lat: route.data.direction_data.routes[0].sections[0].departure.place.originalLocation.lat,
          lng: route.data.direction_data.routes[0].sections[0].departure.place.originalLocation.lng,
        })
        // Convert stored timestamps to Date objects
        const startDate = new Date(route.data.route_info.time_start);
        const endDate = new Date(route.data.route_info.time_end);
    // Determine the correct departure/arrival mode
        const currentTime = new Date().getTime();
        const arrivalTime = endDate.getTime();
        const shouldSetDeparture = arrivalTime < currentTime;
        const isDeparture = shouldSetDeparture ? true : (route.data.route_options?.is_departure ?? true);
        
        this.pickerDates = {
          startDate: startDate,
          endDate: endDate,
          is_departure: isDeparture
        };
        this.startDateUserSet = true;
        this.endDateUserSet = true;
        for await (const section of route.data.direction_data.routes[0].sections) {
          this.selected_points_cloned.push({
            point: {
              address: section.arrival.place.address,
              position: {
                lat: section.arrival.place.originalLocation.lat,
                lng: section.arrival.place.originalLocation.lng,
              }
            },
            origin_locations_open: false,
            points: null,
            showList: false,
            postcode: null,
            postActions: section.postActions || null
          });
          this.selected_points.push({
            lat: section.arrival.place.originalLocation.lat,
            lng: section.arrival.place.originalLocation.lng,
          })
        }

        this.restoreWaypointLabels(this.selected_points_cloned, route);

        // Ensure re-plan page has entry/exit passthroughs immediately (same as plan-v2)
        this.tmp_markers = await this.buildTmpMarkersWithEntryExit(
          this.tmp_markers,
          this.selected_points,
        );
      }

      if(route?.data?.route_options) {
        this.saved_route_options = route?.data?.route_options;
        // Ensure the is_departure flag is properly set
        this.route_options.is_departure = this.pickerDates.is_departure;
        if (route?.data?.route_options?.transport_type) {
          this.saved_option_id = route?.data?.route_options?.transport_type;
          this.transport_type = {
            id: route?.data?.route_options?.transport_type,
            name: route?.data?.route_options?.transport_type
          }
        }
      }

      this.is_edit = true;
      this.showDirections = false;
      this.routeLine = route.data.direction_data;
      let is_vehicles = false;
      if (route.data.vehicle_info) {
        route.data.vehicle_info.forEach((vehicle) => {
          if (vehicle.id) {
            this.selected_vehicles_ids.push(vehicle.id);
            is_vehicles = true;
          }
        });
      }
      if (is_vehicles) {
        const data = await getVehiclesByIds(this.selected_vehicles_ids);
        const { vehicles } = data?.data || {};
        this.selectedVehicles = vehicles || [];
        if (vehicles?.length) {
          this.syncVehicleDimensionsFromVehicles(vehicles);
        } else if (route.data?.route_options?.vehicles_dimensions) {
          this.vehiclesDimensions = structuredClone(route.data.route_options.vehicles_dimensions);
        }
      } else if (route.data?.route_options?.vehicles_dimensions) {
        this.vehiclesDimensions = structuredClone(route.data.route_options.vehicles_dimensions);
      }
      if (route.data.trailer_info?.length) {
        route.data.trailer_info.forEach((trailer) => {
          if (trailer.id) {
            this.selected_trailers_ids.push(trailer.id);
          }
        });
      }
      if (this.selected_trailers_ids.length) {
        const trailerData = await getTrailersByIds(this.selected_trailers_ids);
        const { trailers } = trailerData?.data || {};
        this.selectedTrailers = trailers || [];
        if (trailers?.length) {
          this.syncTrailerDimensionsFromTrailers(trailers);
        } else if (route.data.trailer_info?.length) {
          this.selectedTrailers = route.data.trailer_info;
          this.syncTrailerDimensionsFromTrailers(route.data.trailer_info);
        }
      }

      if (route.data.driver_id) {
        this.selected_driver_id = route.data.driver_id;
      }
    }
  },
  async created() {
    const location = await getUserLocation();
    this.userAt = { lat: location.lat, lng: location.lng };
    this.mapZoom = getMapZoomForLocation(location);
  },
  async mounted() {
    await this.setData()
    if (this.$route.name === 'HereRePlan') {
      await this.setRePlanData();
    }
    this.scheduleExclusionOverlayRefresh();
    document.addEventListener('click', this.handlePlanContextMenuOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handlePlanContextMenuOutsideClick);
  },
  watch: {
    'vehiclesDimensions.weight.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'vehiclesDimensions.height.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'vehiclesDimensions.width.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'vehiclesDimensions.length.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'trailersDimensions.height.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'trailersDimensions.width.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'trailersDimensions.length.val'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'pickerDates.startDate'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'pickerDates.endDate'() {
      this.scheduleExclusionOverlayRefresh();
    },
    'pickerDates.is_departure'() {
      this.scheduleExclusionOverlayRefresh();
    },
  },
  computed: {
    ...mapGetters([
      'getTopBanner',
      'getDropState',
      'getAddVehicles',
      'getAddTrailers'
    ]),
    planMapPickEnabled() {
      return !this.showDirections || this.is_edit;
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-map-context-menu {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  min-width: 220px;
}

.plan-map-context-menu-item {
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;

  &:hover {
    background-color: #f3f4f6;
  }

  &.disabled {
    color: #9ca3af;
    cursor: not-allowed;
    pointer-events: none;
  }
}

/* Your existing styles */
.active {
  &.set-plan {
    display: flex;
  }
}
.set-plan {
  display: none;
}
.vue2leaflet-map {
  height: 877px;
}
.location-name {
  font-weight: bold;
  font-size: 14px;
  color: #292929;
}
.add_items {
  position: absolute;
  top: 180px;
  left: 400px;
  min-height: 150px;
  z-index: 400;
  background-color: #fff;
  border-radius: 5px;
  &.r-side{
    left: calc(35% + 400px);
  }
}
.not-allow-banner {
  padding-top: 150px;
  margin-bottom: 200px;
}
.page {
  position: relative;
  .white-green {
    cursor: pointer;
  }
  .drivers {
    .white-green {
      padding: 12px;
    }
    .expanded {
      overflow: visible;
    }
  }
  .inner {
    &.way {
      max-height: 650px;
      max-width: 350px;
      min-width: 320px;
      overflow-y: auto;
    }
  }
  .vue-range-slider.slider-component {
    .slider {
      .slider-dot {
        background-color: #1fbc2f !important;
      }
    }
  }
  .vehicles {
    .actions {
      .white-green {
        text-align: center;
        margin: auto;
      }
    }
  }
  .vue-range-slider {
    width: 100%!important;
  }
  .alt_header {
    position: absolute;
    height: 50px;
    z-index: 401;
  }
  .outer {
    position: relative;
    .input_actions {
      position: absolute;
      right: 0;
      top: 10px;
      width: 60px;
    }
  }
  .plan_options {
    min-width: 355px;
    position: absolute;
    left: 15px;
    z-index: 401;
    border-radius: 6px;
    background-color: #ffffff;
    .actions {
      .white-green {
        padding-top: 0;
        padding-bottom: 0;
        min-height: 44px;
      }
    }
    &>.inner {
      padding: 15px;
      max-height: 85vh;
      overflow: scroll;
      &.view-plan {
        overflow: hidden;
      }
    }
  }
  .position_plan_options {
    top: 90px;
  }
  .position_plan_options_plus {
    top: 70px;
  }
}
.btn_danger {
  padding: 7px 10px;
}
.input-group {
  input {
    border: 1px solid #D0D5DA;
    box-sizing: border-box;
    border-radius: 18px;
  }
}
.plan_item {
  .expand {
    padding-right: 10px;
    .active {
      svg {
        transform: rotate(180deg);
      }
    }
  }
  .mb30 {
    .flex {
      width: 100%;
      .mr-2 {
        margin: 0;
        width: 100%;
      }
      .vue-daterange-picker {
        width: 100%;
      }
    }
  }
}
.actions {
  &.save {
    padding-top: 15px;
    button {
      min-width: 80px;
    }
  }
}
.preferences {
  input[type="radio"] {
    max-width: 20px;
    &:checked {
      &:checked {
        background: #FFA800 !important;
        border: #FFA800 !important;
      }
      &:before, &:after {
        background: #FFA800 !important;
        border: #FFA800 !important;
      }
    }
  }
}
.vue-daterange-picker ::v-deep .reportrange-text{
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 18px !important;
  width: 100%;
}
.data {
  padding-bottom: 20px;
  .icon {
    width: 20px;
  }
}
.icon {
  &.rotated {
    width: 44px;
    height: 44px;
    background: #fff;
    border-radius: 8px;
    left: 15px;
    position: absolute;
    top: 150px;
    z-index: 999;
  }
}
.add_name {
  position: absolute;
  max-width: 400px;
  left: 0;
  right: 0;
  top: 300px;
  margin: auto;
  z-index: 401;
  background: #fff;
}
.closeZone {
  transform: rotate(180deg);
  float: left;
}
.openZone {
  background: #fff;
  padding: 5px 5px;
  border-radius: 4px;
  width: 34px;
  border: 2px solid rgba(0,0,0,.2);
  background-clip: padding-box;
}
.custom-control {
  .controls {
    width: 230px;
    height: 150px;
    padding-left: 15px;
    background-color: #fff;
    img {
      max-width: 20px;
    }
  }
}
.no_visibility {
  opacity: 0;
}
.dropdown_block {
  width: 100%;
  padding: 0 10px;
  z-index: 405;
  background: #ffffff;
  border: 1px solid #D0D5DA;
  box-sizing: border-box;
  border-radius: 5px;
  position: absolute;
  top: 54px;
  left: 0;
}
.title {
  font-size: 14px;
}
.locations{
  &.absolute {
    background-color: #fff;
    width: 100%;
    z-index: 100;
  }
}
.down {
  .rotate {

  }
}
</style>